export const GUIDED_SEARCH_CTAREF_PREFIX = "guided search - ";

export const normaliseGuidedSearchTerm = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

export const buildGuidedSearchTrackingValue = ({
  sourceSearchTerm,
  destinationSearchTerm,
}) => {
  const sourceTerm = normaliseGuidedSearchTerm(sourceSearchTerm);
  const destinationTerm = normaliseGuidedSearchTerm(destinationSearchTerm);

  if (!sourceTerm || !destinationTerm) {
    return undefined;
  }

  return `${GUIDED_SEARCH_CTAREF_PREFIX}${sourceTerm}|${destinationTerm}`;
};

export const getSearchTermFromLinkUrl = (linkUrl) => {
  if (typeof linkUrl !== "string" || linkUrl.length === 0) {
    return "";
  }

  const [, queryString = ""] = linkUrl
    .replace(/^https?:\/\/[^/]+/i, "")
    .split("?");

  return normaliseGuidedSearchTerm(new URLSearchParams(queryString).get("q"));
};

export const appendGuidedSearchTrackingToUrl = ({
  linkUrl,
  sourceSearchTerm,
  destinationSearchTerm,
}) => {
  const guidedSearchTracking = buildGuidedSearchTrackingValue({
    sourceSearchTerm,
    destinationSearchTerm,
  });

  if (!linkUrl || !guidedSearchTracking) {
    return {
      linkUrl,
      guidedSearchTracking,
    };
  }

  const parsedUrl = new URL(linkUrl, "https://www.asos.com");
  parsedUrl.searchParams.set("ctaref", guidedSearchTracking);

  return {
    guidedSearchTracking,
    linkUrl: /^https?:\/\//i.test(linkUrl)
      ? parsedUrl.toString()
      : `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`,
  };
};

export const getGuidedSearchTrackingFromLocation = (location) => {
  const ctaRefValue =
    typeof location?.query?.ctaref === "string"
      ? location.query.ctaref
      : new URLSearchParams(location?.search).get("ctaref");

  const normalisedValue = normaliseGuidedSearchTerm(ctaRefValue);

  return normalisedValue.startsWith(GUIDED_SEARCH_CTAREF_PREFIX)
    ? normalisedValue
    : "";
};
